import useComputed from '@/hooks/use-computed'
import api from '@/services/api/org.js'
import { useState } from 'react'

const useOrg = (_enrolmentId) => {

	const [items, setItems] = useComputed([])

	const [currentItem ,setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()
	const [allData, setAllData] = useState();

	async function fetch(parameter) {
		setLoading(true)

		const params = parameter ? parameter : "";

		const [errorResponse, data] = await api.index({params})
		setLoading(false)

		if (errorResponse) {
			return setError(errorResponse)
		}

		setAllData(data);
		setItems(data.items);
	}

	async function find(parameter) {
		setLoading(true)

		const params = parameter ? parameter : "";

		const [errorResponse, data] = await api.index({
			params
		})

		setLoading(false)

		if (errorResponse) {
			return setError(errorResponse)

		}

		if (!Array.isArray(data)) {
			return setError('Organisation is not an array')
		}

		return data
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		find,
		items,
		currentItem,
		setCurrentItem,
		setItems,
		loading,
		view,
		allData
	}

}

export default useOrg;
